import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
export const NewsImageDisplay = ({ src, withBorder = true, maxWidthStyle = '75vw' }) => {
    return (_jsx("img", { css: css `
        max-width: ${maxWidthStyle};
        height: auto;
        border: ${withBorder ? '2px solid black' : 'initial'};
      `, src: src }));
};
